import React, { useEffect, useState } from 'react';
import { popupMessage } from '../../../constants/constants.js'; 

export function ChoiceMeals (props) {
  const { types, handleCheckBox } = props;
  const filteredMeals = types.filter(
    ({ nameEn, boolean }) => (nameEn === 'supper' || nameEn === 'dinner') && boolean
  );

  return (
    <fieldset className='flexColStart'>
      <legend className='form__legend_period font20EB color'>Выберите приемы пищи</legend>
      <div className='flexColStart'>
        <TypesFood handleCheckBox={handleCheckBox} types={types} />
        {filteredMeals.map(meal => (
          <ChoiceDish key={meal.nameEn} meal={meal} handleCheckBox={handleCheckBox} />
        ))}
      </div>
    </fieldset>
  );
}

export function ChoiceDish ({ meal, handleCheckBox }) {
  const [dishes, setDishes] = useState(meal.dish);

  const handleChange = (updatedDish) => {
    const updatedDishes = dishes.map(dish => dish.nameEn === updatedDish.nameEn ? updatedDish : dish);
    setDishes(updatedDishes);
    handleCheckBox({ ...meal, dish: updatedDishes });
  };

  return (
    <div className='form__meals_group'>
      <p className='form__meals_subtitle font20EB colorGrey'>{`Выберите блюда для ${meal.nameRu}а`}</p>
      <TypesFood handleCheckBox={handleChange} types={dishes} />
    </div>
  );
}

export function TypesFood ({ types, handleCheckBox }) {
  return (
    <ul className='form__block_type'>
      {types.length > 0 && types.map(item => (
        <TypeFood key={item.nameEn} item={item} onClick={handleCheckBox} />
      ))}
    </ul>
  );
}

export function TypeFood ({ item, onClick }) {
  const [isActive, setIsActive] = useState(item.boolean); 

  useEffect(() => {
    setIsActive(item.boolean);
  }, [item]);

  const handleClick = () => {
    setIsActive(prev => !prev);
    onClick({ ...item, boolean: !isActive });
  };

  return (
    <div className='diet__block'>
      <li onClick={handleClick} className={`buttonType font20Norm ${isActive ? 'fon-colors' : ''}`}>
        {item.nameRu}
      </li>
    </div>
  );
}